import { useState } from "react";
import PropTypes from "prop-types";
import { ChevronDown } from "lucide-react";

export function CollapsibleSection({ title, icon: Icon, defaultOpen = false, isOpen, onToggle, children }) {
  const [internalOpen, setInternalOpen] = useState(defaultOpen);
  const controlled = isOpen !== undefined;
  const open = controlled ? isOpen : internalOpen;

  const handleToggle = () => {
    if (controlled && onToggle) {
      onToggle();
    } else {
      setInternalOpen(prev => !prev);
    }
  };

  return (
    <div className={`collapsible-section ${open ? "" : "collapsible-section--collapsed"}`}>
      <button type="button" className="collapsible-section__header" onClick={handleToggle}>
        <div className="collapsible-section__left">
          {Icon && <Icon size={16} className="collapsible-section__icon" />}
          <span className="collapsible-section__title">{title}</span>
        </div>
        <ChevronDown
          size={16}
          className={`collapsible-section__chevron ${open ? "" : "collapsible-section__chevron--closed"}`}
        />
      </button>
      <div
        className={`collapsible-section__body ${open ? "collapsible-section__body--open" : "collapsible-section__body--closed"}`}
      >
        {children}
      </div>
    </div>
  );
}

CollapsibleSection.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.elementType,
  defaultOpen: PropTypes.bool,
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
  children: PropTypes.node.isRequired,
};

CollapsibleSection.defaultProps = {
  icon: null,
  defaultOpen: false,
  isOpen: undefined,
  onToggle: undefined,
};

export default CollapsibleSection;
